import type { UploadingOptions } from '@/store/file-uploader.interface';
import type { FileVersion } from '@/store/file.interface';

export abstract class BaseFileUploader {
  protected readonly _version: FileVersion;

  protected constructor(version: FileVersion) {
    this._version = version;
  }

  public abstract upload(options: UploadingOptions): Promise<void>;
}
